import { BasicModel } from '@/store/creative/model-editor/index'
import {
  TransformTypes,
  VectorKeys,
} from '@/store/creative/model-editor/index.type'

export default function (key: keyof BasicModel): {
  transformType: TransformTypes
  vectorKey: VectorKeys
} {
  let transformType: TransformTypes = 'position'
  const cookKey = key.slice(0, key.length - 1).toLowerCase()
  switch (cookKey) {
    case 'translate':
      transformType = 'position'
      break
    case 'rotate':
      transformType = 'eulerAngles'
      break
    case 'scale':
      transformType = 'scale'
      break
    default:
      transformType = 'position'
      break
  }
  return {
    transformType,
    vectorKey: key[key.length - 1]!.toLowerCase() as VectorKeys,
  }
}
